"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _shared = require("../shared");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ContainerCategoryList = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ContainerCategoryList, _Component);

  var _super = _createSuper(ContainerCategoryList);

  function ContainerCategoryList() {
    var _this;

    (0, _classCallCheck2.default)(this, ContainerCategoryList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "childCategories", _this.props.category.children);
    return _this;
  }

  (0, _createClass2.default)(ContainerCategoryList, [{
    key: "render",
    value: function render() {
      var _this$childCategories;

      var categoriesContent = this.props.categoriesContent;
      return (0, _preact.h)("div", null, (_this$childCategories = this.childCategories) === null || _this$childCategories === void 0 ? void 0 : _this$childCategories.map(function (_ref) {
        var id = _ref.id,
            title = _ref.title,
            url = _ref.url,
            isContainer = _ref.isContainer,
            children = _ref.children;
        return (0, _preact.h)(_shared.CategoryListCard, {
          key: id,
          title: title,
          url: url,
          showAllLink: !isContainer
        }, isContainer ? (0, _preact.h)("div", null, children.map(function (childCategory) {
          return (0, _preact.h)(_shared.CategoryCardItem, {
            key: "category-item-".concat(childCategory.id),
            title: childCategory.title,
            url: childCategory.url
          });
        })) : (0, _preact.h)("div", null, categoriesContent && id in categoriesContent && categoriesContent[id].map(function (topic) {
          return (0, _preact.h)(_shared.CategoryTopicListItem, {
            key: topic.id,
            topic: topic
          });
        })));
      }));
    }
  }]);
  return ContainerCategoryList;
}(_preact.Component);

var _default = ContainerCategoryList;
exports.default = _default;